module.exports = __webpack_public_path__ + "static/race2-6aa5916cf7e33f886f32448db92dd0f2.png";